export * from './tab.component';
export * from './tabs.component';



// WEBPACK FOOTER //
// ./src/app/components/ng-tabs/ng-tabs.ts